import { ReactNode } from 'react';

import LayoutBox1 from '~/shared/assets/icons/layout-box-1.svg';
import LayoutBox2 from '~/shared/assets/icons/layout-box-2.svg';

import Header from './Header';
import Sidebar from './Sidebar';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="h-full w-full flex relative">
      <Sidebar />

      <div className="flex-1 flex flex-col max-w-full overflow-x-auto  relative bg-bg">
        <Header />
        <div className="flex-1 flex flex-col px-[24px] relative z-[1]">{children}</div>

        <div
          className="absolute inset-0 h-[390px] w-full "
          style={{ background: 'linear-gradient(180deg, #0A2687 0%, #2549C1 100%)' }}
        >
          <div className="relative h-full w-full">
            <LayoutBox1 className="absolute top-0 right-0" />
            <LayoutBox2 className="absolute top-[36px] right-[194.68px]" />
          </div>
        </div>
      </div>
    </div>
  );
}
